import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

addToListModalStyles.listsSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
        `,
        list: css`
        >div[aria-selected^="true"] {
            color: ${getColor("common.background")};
            &:hover{
                color: ${getColor("secondary")}; 
            }
        }
        `,
        option: css`
        color: ${getColor("secondary")};
        &:hover{
            color: ${getColor("secondary")}; 
        }
        `,
    },
}